document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cs-slider').forEach(slider => {
    const track = slider.querySelector('.cs-track');
    const cards = slider.querySelectorAll('.cs-card');
    const prev = slider.querySelector('.swiper-button-prev');
const next = slider.querySelector('.swiper-button-next');
    const viewport = slider.querySelector('.cs-right');

    if (!track || cards.length === 0 || !viewport) return;

    let cardWidth = 0;
    let maxX = 0;
    let currentX = 0;
    let draggable;

    function measure() {
const cardRect = cards[0].getBoundingClientRect();
const nextCard = cards[1];

let gap = 0;
if (nextCard) {
  gap =
    nextCard.getBoundingClientRect().left -
    cardRect.right;
}

cardWidth = cardRect.width + gap;

      maxX = Math.min(0, viewport.offsetWidth - track.scrollWidth);
    }

    function clamp(x) {
      return Math.max(maxX, Math.min(0, x));
    }

function snap(x) {
  const rawIndex = x / cardWidth;

  const index =
    rawIndex < 0
      ? Math.ceil(rawIndex - 0.5)
      : Math.floor(rawIndex + 0.5);

  const snapped = index * cardWidth;

  return Math.max(maxX, Math.min(0, snapped));
}



    function goTo(x, animate = true) {
      currentX = snap(x);
      gsap.to(track, {
        x: currentX,
        duration: animate ? 0.35 : 0,
        ease: 'power3.out'
      });
    }

    measure();

draggable = Draggable.create(track, {
  type: 'x',

  bounds: () => ({ minX: maxX, maxX: 0 }),

  inertia: true,

  /* 🔑 SMOOTHNESS TUNING */
  dragResistance: 0.05,
  edgeResistance: 0.75,
  throwResistance: 2000,
  overshootTolerance: 0.3,

  allowContextMenu: true,

  onPress() {
    gsap.killTweensOf(track);
  },

 onDrag() {
  currentX = this.x;
},

onRelease() {
  goTo(this.x);
},

  onThrowComplete() {
    goTo(this.x);
  }
})[0];

    prev?.addEventListener('click', () => {
      goTo(currentX + cardWidth);
    });

    next?.addEventListener('click', () => {
      goTo(currentX - cardWidth);
    });

    window.addEventListener('resize', () => {
      measure();
      draggable.applyBounds({ minX: maxX, maxX: 0 });
      goTo(currentX, false);
    });
  });
});
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.cs-fade-in').forEach(el => {
    requestAnimationFrame(() => {
      el.classList.add('is-visible');
    });
  });
});
